<div *ngIf="loading" class="text-center pt-5">
	<app-loading-spinner></app-loading-spinner>
</div>

<div id="folder-list" class="mb-2">
	<div class="row justify-content-beetwen g-2">
		<div class="col">
			<h3 class="mb-0">{{ editMode ? 'Edit' : 'Create'}} Baseline</h3>
		</div>
		<div class="col-auto">
			<div class="d-flex gap-2 align-items-start">
				<a routerLink="/baselines" class="btn btn-danger w-sm create-folder-modal flex-shrink-0">Cancel</a>
			</div>
		</div>
	</div>
</div>

<div class="card h-100" style="box-shadow: none">
	<div class="card-header border-0">
		<div class="progress progress-step-arrow progress-info">
			<div class="progress-bar w-100" *ngFor="let step of steps; let i = index" [ngClass]="i === currentStep+1 ? 'next' : i > currentStep+1 ? 'bg-light text-body after' : ''">{{ step }}</div>
		</div>
	</div>
	<div [ngSwitch]="currentStep" class="card-body h-100 pt-0 border-0">
		<ngx-simplebar class="px-3 file-manager-content-scroll">
			<div *ngSwitchCase="0">
				<form>
					<div class="mb-3">
						<div class="row">
							<div class="col-lg-4 col-12">
								<label for="name" class="form-label">Baseline name <span class="text-danger">*</span></label>
								<input type="text" class="form-control" id="name" placeholder="Enter baseline name" required [(ngModel)]="baseline_name" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !baseline_name }">
								<div class="invalid-feedback"> Please enter baseline name </div>
							</div>
							<div class="col-4">
								<label for="lang" class="form-label">Baseline Language <span class="text-danger">*</span></label>
								<ng-select id="lang" [items]="listLang" bindLabel="name" bindValue="lang" [clearable]="false" placeholder="Select a language" [(ngModel)]="selectedLanguage" [ngModelOptions]="{standalone: true}">
									<ng-template ng-label-tmp let-item="item">
										<img height="15" width="15" [src]="item.flag" alt="item.text" />
										<span class="ms-2">{{ item.text }}</span>
									</ng-template>
									<ng-template ng-option-tmp let-item="item" let-index="index">
										<img height="15" width="15" [src]="item.flag" alt="item.text" />
										<span class="ms-2">{{ item.text }}</span>
									</ng-template>
								</ng-select>
							</div>
							<div class="col-4">
								<label for="baseline_status" class="form-label">Baseline Status <span class="text-danger">*</span></label>
								<ng-select id="baseline_status" [items]="listStatus" [clearable]="false" placeholder="Select a status" [(ngModel)]="status" [ngModelOptions]="{standalone: true}">
									<ng-template ng-label-tmp let-item="item">
										<span>{{ item.name | titlecase  }}</span>
									</ng-template>
									<ng-template ng-option-tmp let-item="item" let-index="index">
										<span>{{ item.name | titlecase }}</span>
									</ng-template>
								</ng-select>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<label for="description" class="form-label">Description</label>
						<quill-editor id="description" [placeholder]="'Insert baseline description here...'" [styles]="{ height: '250px' }" [(ngModel)]="description" [ngModelOptions]="{standalone: true}" class="d-block"></quill-editor>
					</div>
				</form>	
			</div>
			<div *ngSwitchCase="1">
				<div>
					<div class="d-flex align-items-center justify-content-between mb-3"> 
						<h5 class="mb-0 fw-semibold">Questions</h5>
						<button class="btn btn-primary" (click)="addQuestion()">+ Add New Question</button>
					</div>
					<ngx-simplebar class="file-manager-question-scroll">
						<div ngbAccordion activeIds="static-1" [closeOthers]="true" class="custom-accordionwithicon accordion-border-box">
							<div *ngFor="let question of questions; let q = index;" ngbAccordionItem  id="question-{{ q+1 }}">
								<h2 ngbAccordionHeader class="accordion-header border-0 bg-transparent d-flex w-100 justify-content-between align-items-center">
									<button ngbAccordionButton> 
										<span >{{ question.name ? question.name : 'Question-' + (q+1) }}</span>
										<span *ngIf="question.status" class="ms-3 text-danger"> *There are required fields in this question that have not been filled</span>
										<span type="button" ngbTooltip="Duplicate Question" class="btn btn-sm btn-info add-btn ms-auto me-2" (click)="duplicateQuestion($event, question)"><i class="ri-file-copy-2-line"></i></span>
										<span type="button" ngbTooltip="Preview Question" class="btn btn-sm btn-success add-btn me-2" (click)="viewQuestion($event, q)"><i class="ri-eye-line"></i></span>
										<span type="button" ngbTooltip="Delete Question" class="btn btn-sm btn-danger add-btn me-3" (click)="openDeleteQuestionModal($event, deleteQuestionModal, q)"><i class="ri-delete-bin-5-line"></i></span>
									</button>
								</h2>
								<div ngbAccordionCollapse>
									<div ngbAccordionBody>
										<ng-template> 
											<app-chapter-questions [themeList]="themeList" [question]="question" [questionID]="'-question-' + q"></app-chapter-questions>
										</ng-template>
									</div>
								</div>
							</div>
						</div>
					</ngx-simplebar>
				</div>
			</div>
			<div *ngSwitchCase="2">
				<div class="card">
					<div class="row">
						<div class="col-lg-12">
							<div class="card-body border-bottom border-bottom-dashed">
								<div class="row g-3">
									<div class="col-lg-3 col-6">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Baseline Name</p>
										<h5 class="fs-15 mb-0">{{ baseline_name }}</h5>
									</div>
									<div class="col-lg-3 col-6">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Date</p>
										<h5 class="fs-15 mb-0">{{ today | date:'MMM d, y, h:mm a' }}</h5>
									</div>
									<div class="col-lg-3 col-6">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Status</p>
										<span class="badge bg-{{ status.status_color }}-subtle text-{{ status.status_color }} fs-11">{{ status.name }}</span>
									</div>
									<div class="col-lg-3 col-6">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Total Quesions</p>
										<h5 class="fs-15 mb-0">{{ questions.length }}</h5>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-12">
							<div class="card-body">
								<h5 class="fs-15 mb-3">Questions</h5>
								<div ngbAccordion activeIds="static-1" [closeOthers]="true" class="custom-accordionwithicon accordion-border-box">
									<div *ngFor="let question of questions; let q = index;" ngbAccordionItem  id="question-{{ q+1 }}">
										<h2 ngbAccordionHeader class="accordion-header border-0 bg-transparent d-flex w-100 justify-content-between align-items-center">
											<button ngbAccordionButton>
												<span class="me-auto">{{ question.name ? question.name : 'Question-' + (q+1) }}</span>
											</button>
										</h2>
										<div ngbAccordionCollapse>
											<div ngbAccordionBody>
												<ng-template> 
													<app-view-chapter-question [question_summary]="true" [chapter_name]="'baseline'" [lang_code]="selectedLanguage" [question]="question" [questionID]="'-question-' + q"></app-view-chapter-question>
												</ng-template>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ngx-simplebar>
		<div class="row mt-2">
			<div *ngIf="currentStep > 0" class="me-auto col">
				<button (click)="backStep()" class="btn btn-primary btn-load">Back</button>
			</div>
			<div class="text-end col">
				<button (click)="currentStep < steps.length-1 ? nextStep() : saveBaseline()" class="btn btn-primary btn-load">
					<span class="d-flex justify-question-center">
						<span class="spinner-border" role="status" *ngIf="submitted && spinner">
							<span class="visually-hidden">Loading...</span>
						</span>
						<span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ currentStep < steps.length-1 ? 'Next' :  editMode ? 'update' : 'Create' }} </span>
					</span>
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteQuestionModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
				<div class="alert alert-danger">
					<p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
				</div>
				<div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you Sure You want to delete</h4>
          <h4><span class="fw-semibold text-warning">{{ 'Question-' + (questionIndex+1) }}</span>?</h4>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
				<button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteQuestion()">
					<span class="d-flex justify-content-center">
						<span class="spinner-border" role="status" *ngIf="submitted && spinner">
							<span class="visually-hidden">Loading...</span>
						</span>
						<span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
					</span>
				</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewQuestionModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
    </div>
		<div class="modal-body p-4">
			<app-view-chapter-question [question_index]="selectedQuestionIndex" [question_length]="questions.length" [chapter_name]="'baseline'" [lang_code]="selectedLanguage" [question]="selectedQuestion" [questionID]="'question-' + selectedQuestionIndex"></app-view-chapter-question>
		</div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
				<lord-icon *ngIf="success" src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
				<lord-icon *ngIf="!success" src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
				<p *ngIf="!success" class="text-muted mx-4 mb-0">{{ message }}</p>
      </div>
    </div>
  </div>
</ng-template>